import {
  Box,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  styled,
  Button,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText
} from '@mui/material';
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useEffect, useState } from 'react';
import { api } from '../../../api';
import { SystemConfig } from '../../../schema/system_config';

const ClearLog = () => {
  const [external_log_clear_days, set_external_log_clear_days] = useState<number | null>(null);
  const [external_log_clear_time, set_external_log_clear_time] = useState<Date | null>(null);
  const [exchange_card_log_clear_days, set_exchange_card_log_clear_days] = useState<number | null>(
    null
  );
  const [exchange_card_log_clear_time, set_exchange_card_log_clear_time] = useState<Date | null>(
    null
  );
  const [acc_device_scan_log_clear_days, set_acc_device_scan_log_clear_days] = useState<
    number | null
  >(null);
  const [acc_device_scan_log_clear_time, set_acc_device_scan_log_clear_time] =
    useState<Date | null>(null);
  const [in_out_log_clear_days, set_in_out_log_clear_days] = useState<number | null>(null);
  const [in_out_log_clear_time, set_in_out_log_clear_time] = useState<Date | null>(null);
  const [working_log_clear_days, set_working_log_clear_days] = useState<number | null>(null);
  const [working_log_clear_time, set_working_log_clear_time] = useState<Date | null>(null);
  const [isOpenSuccessDialog, setIsOpenSuccessDialog] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const openSuccessDialog = () => {
    setIsOpenSuccessDialog(true);
    setTimeout(() => {
      setIsOpenSuccessDialog(false);
    }, 1000);
  };
  const handleFormSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (isLoading) {
      return;
    }
    if (
      external_log_clear_days &&
      external_log_clear_time &&
      exchange_card_log_clear_days &&
      exchange_card_log_clear_time &&
      acc_device_scan_log_clear_days &&
      acc_device_scan_log_clear_time &&
      in_out_log_clear_days &&
      in_out_log_clear_time &&
      working_log_clear_days &&
      working_log_clear_time
    ) {
      setIsLoading(true);
      api
        .post(`/system_config/clear_log`, {
          external_log_clear_days,
          external_log_clear_time: external_log_clear_time
            ? `${external_log_clear_time.getHours()}:${external_log_clear_time.getMinutes()}`
            : null,
          exchange_card_log_clear_days,
          exchange_card_log_clear_time: exchange_card_log_clear_time
            ? `${exchange_card_log_clear_time.getHours()}:${exchange_card_log_clear_time.getMinutes()}`
            : null,
          acc_device_scan_log_clear_days,
          acc_device_scan_log_clear_time: acc_device_scan_log_clear_time
            ? `${acc_device_scan_log_clear_time.getHours()}:${acc_device_scan_log_clear_time.getMinutes()}`
            : null,
          in_out_log_clear_days,
          in_out_log_clear_time: in_out_log_clear_time
            ? `${in_out_log_clear_time.getHours()}:${in_out_log_clear_time.getMinutes()}`
            : null,
          working_log_clear_days,
          working_log_clear_time: working_log_clear_time
            ? `${working_log_clear_time.getHours()}:${working_log_clear_time.getMinutes()}`
            : null
        })
        .then(() => {
          openSuccessDialog();
        })
        .finally(() => setIsLoading(false));
    }
  };

  useEffect(() => {
    api.get<SystemConfig>(`/system_config`).then((res) => {
      const { data } = res;
      set_external_log_clear_days(data.external_log_clear_days);
      if (data.external_log_clear_time) {
        set_external_log_clear_time(new Date('2000-01-20T' + data.external_log_clear_time));
      }
      set_exchange_card_log_clear_days(data.exchange_card_log_clear_days);
      if (data.external_log_clear_time) {
        set_exchange_card_log_clear_time(
          new Date('2000-01-20T' + data.exchange_card_log_clear_time)
        );
      }
      set_acc_device_scan_log_clear_days(data.acc_device_scan_log_clear_days);
      if (data.acc_device_scan_log_clear_time) {
        set_acc_device_scan_log_clear_time(
          new Date('2000-01-20T' + data.acc_device_scan_log_clear_time)
        );
      }
      set_in_out_log_clear_days(data.in_out_log_clear_days);
      if (data.in_out_log_clear_time) {
        set_in_out_log_clear_time(new Date('2000-01-20T' + data.in_out_log_clear_time));
      }
      set_working_log_clear_days(data.working_log_clear_days);
      if (data.working_log_clear_time) {
        set_working_log_clear_time(new Date('2000-01-20T' + data.working_log_clear_time));
      }
    });
  }, []);

  return (
    <Box>
      <Form onSubmit={handleFormSubmit}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box sx={{ mb: 2, width: '100%' }}>
            <Typography variant="h6" sx={{ p: 1 }}>
              ข้อมูลภายนอก
            </Typography>
            <Paper sx={{ padding: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="external_log_clear_days">ระยะเวลาลบข้อมูลย้อนหลัง</InputLabel>
                    <Select
                      labelId="external_log_clear_days"
                      label="ระยะเวลาลบข้อมูลย้อนหลัง"
                      variant="outlined"
                      onChange={(e) => set_external_log_clear_days(parseInt(e.target.value))}
                      value={`${external_log_clear_days}`}
                      autoComplete="off"
                    >
                      <MenuItem value="90">3 เดือน</MenuItem>
                      <MenuItem value="180">6 เดือน</MenuItem>
                      <MenuItem value="365">1 ปี</MenuItem>
                      <MenuItem value="730">2 ปี</MenuItem>
                      <MenuItem value="1095">3 ปี</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <TimePicker
                    label="ช่วงเวลาล้างข้อมูล"
                    value={external_log_clear_time}
                    onChange={(value) => set_external_log_clear_time(value ? value : null)}
                    inputFormat="HH:mm"
                    ampm={false}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        {...params}
                        variant="outlined"
                        placeholder="ช่วงเวลาล้างข้อมูล"
                        autoComplete="off"
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Box>

          <Box sx={{ mb: 2, width: '100%' }}>
            <Typography variant="h6" sx={{ p: 1 }}>
              ข้อมูลการแลกบัตรเข้าออก
            </Typography>
            <Paper sx={{ padding: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="exchange_card_log_clear_days">
                      ระยะเวลาลบข้อมูลย้อนหลัง
                    </InputLabel>
                    <Select
                      labelId="exchange_card_log_clear_days"
                      label="ระยะเวลาลบข้อมูลย้อนหลัง"
                      variant="outlined"
                      onChange={(e) => set_exchange_card_log_clear_days(parseInt(e.target.value))}
                      value={`${exchange_card_log_clear_days}`}
                      autoComplete="off"
                    >
                      <MenuItem value="90">3 เดือน</MenuItem>
                      <MenuItem value="180">6 เดือน</MenuItem>
                      <MenuItem value="365">1 ปี</MenuItem>
                      <MenuItem value="730">2 ปี</MenuItem>
                      <MenuItem value="1095">3 ปี</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <TimePicker
                    label="ช่วงเวลาล้างข้อมูล"
                    value={exchange_card_log_clear_time}
                    onChange={(value) => set_exchange_card_log_clear_time(value ? value : null)}
                    inputFormat="HH:mm"
                    ampm={false}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        {...params}
                        variant="outlined"
                        placeholder="ช่วงเวลาล้างข้อมูล"
                        autoComplete="off"
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Box>

          <Box sx={{ mb: 2, width: '100%' }}>
            <Typography variant="h6" sx={{ p: 1 }}>
              ข้อมูลการสแกนเข้าออก
            </Typography>
            <Paper sx={{ padding: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="acc_device_scan_log_clear_days">
                      ระยะเวลาลบข้อมูลย้อนหลัง
                    </InputLabel>
                    <Select
                      labelId="acc_device_scan_log_clear_days"
                      label="ระยะเวลาลบข้อมูลย้อนหลัง"
                      variant="outlined"
                      onChange={(e) => set_acc_device_scan_log_clear_days(parseInt(e.target.value))}
                      value={`${acc_device_scan_log_clear_days}`}
                      autoComplete="off"
                    >
                      <MenuItem value="90">3 เดือน</MenuItem>
                      <MenuItem value="180">6 เดือน</MenuItem>
                      <MenuItem value="365">1 ปี</MenuItem>
                      <MenuItem value="730">2 ปี</MenuItem>
                      <MenuItem value="1095">3 ปี</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <TimePicker
                    label="ช่วงเวลาล้างข้อมูล"
                    value={acc_device_scan_log_clear_time}
                    onChange={(value) => set_acc_device_scan_log_clear_time(value ? value : null)}
                    inputFormat="HH:mm"
                    ampm={false}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        {...params}
                        variant="outlined"
                        placeholder="ช่วงเวลาล้างข้อมูล"
                        autoComplete="off"
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Box>

          <Box sx={{ mb: 2, width: '100%' }}>
            <Typography variant="h6" sx={{ p: 1 }}>
              ข้อมูลการเข้าออกการทำงาน
            </Typography>
            <Paper sx={{ padding: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="in_out_log_clear_days">ระยะเวลาลบข้อมูลย้อนหลัง</InputLabel>
                    <Select
                      labelId="in_out_log_clear_days"
                      label="ระยะเวลาลบข้อมูลย้อนหลัง"
                      variant="outlined"
                      onChange={(e) => set_in_out_log_clear_days(parseInt(e.target.value))}
                      value={`${in_out_log_clear_days}`}
                      autoComplete="off"
                    >
                      <MenuItem value="90">3 เดือน</MenuItem>
                      <MenuItem value="180">6 เดือน</MenuItem>
                      <MenuItem value="365">1 ปี</MenuItem>
                      <MenuItem value="730">2 ปี</MenuItem>
                      <MenuItem value="1095">3 ปี</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <TimePicker
                    label="ช่วงเวลาล้างข้อมูล"
                    value={in_out_log_clear_time}
                    onChange={(value) => set_in_out_log_clear_time(value ? value : null)}
                    inputFormat="HH:mm"
                    ampm={false}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        {...params}
                        variant="outlined"
                        placeholder="ช่วงเวลาล้างข้อมูล"
                        autoComplete="off"
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Box>

          <Box sx={{ mb: 2, width: '100%' }}>
            <Typography variant="h6" sx={{ p: 1 }}>
              ข้อมูลเวลาการทำงาน
            </Typography>
            <Paper sx={{ padding: 3 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id="working_log_clear_days">ระยะเวลาลบข้อมูลย้อนหลัง</InputLabel>
                    <Select
                      labelId="working_log_clear_days"
                      label="ระยะเวลาลบข้อมูลย้อนหลัง"
                      variant="outlined"
                      onChange={(e) => set_working_log_clear_days(parseInt(e.target.value))}
                      value={`${working_log_clear_days}`}
                      autoComplete="off"
                    >
                      <MenuItem value="90">3 เดือน</MenuItem>
                      <MenuItem value="180">6 เดือน</MenuItem>
                      <MenuItem value="365">1 ปี</MenuItem>
                      <MenuItem value="730">2 ปี</MenuItem>
                      <MenuItem value="1095">3 ปี</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={6}>
                  <TimePicker
                    label="ช่วงเวลาล้างข้อมูล"
                    value={working_log_clear_time}
                    onChange={(value) => set_working_log_clear_time(value ? value : null)}
                    inputFormat="HH:mm"
                    ampm={false}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        {...params}
                        variant="outlined"
                        placeholder="ช่วงเวลาล้างข้อมูล"
                        autoComplete="off"
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Box>
        </LocalizationProvider>
        <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
          บันทึก
        </Button>
      </Form>
      <Dialog open={isOpenSuccessDialog} onClose={() => setIsOpenSuccessDialog(false)}>
        <DialogTitle>{'Success'}</DialogTitle>
        <DialogContent>
          <DialogContentText>อัพเดทข้อมูลการตรวจสอบและอัปเดตบุคคลสำเร็จ</DialogContentText>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ClearLog;

const Form = styled('form')`
  display: flex;
  flex-direction: column;
  align-items: end;
`;
